import { openInNewTab } from '@/util/url';
import { useLazyQuery, useQuery } from '@apollo/client';
import { ProductboardUrlDocument } from '@common/graphql/generated';
import Icon from '../common/icons/Icon';
import LeftNavActionButton from '../common/pageLayout/LeftNavActionButton';

const ProductboardButton = () => {
    const { data } = useQuery(ProductboardUrlDocument, {
        fetchPolicy: 'no-cache',
    });
    const [queryProductboardUrl] = useLazyQuery(ProductboardUrlDocument, {
        fetchPolicy: 'no-cache',
    });

    return (
        <LeftNavActionButton
            text="See our roadmap"
            icon={<Icon name="Map01" />}
            onClick={() => {
                // Open the productboard URL if it's available,
                // otherwise query for it and then open it.
                // This allows us to show the button immediately
                // even if the URL is not available yet.
                if (data?.productboardUrl) {
                    openInNewTab(data.productboardUrl);
                } else {
                    queryProductboardUrl().then((result) => {
                        if (result.data?.productboardUrl) {
                            openInNewTab(result.data.productboardUrl);
                        }
                    });
                }
            }}
            onClickEvent="Productboard Left Nav Action Button Clicked"
        />
    );
};

export default ProductboardButton;
